import { TScenesReplay } from "../components/menu/Scenes/replayScenes/ScenesReplay";
import { replayScenesList, ScenesReplayListKey } from "../components/menu/Scenes/replayScenes/scenesReplayData";
import { setAdvance } from "../store/slices/AdvanceSlice";
import { setCurrentScene } from "../store/slices/gameObjectSlice";
import { GameNames } from "../store/slices/GameTypes";
import { setGallery, setMenu } from "../store/slices/menuSlice";
import { store } from "../store/store";
import { Action, Node } from "./Actions/Action";
import Game from "./Game";
import { onSaveGallery } from "./utils/appManagementFunctions";

export const endReplayFunc = () => {
    Game.isReplayRunning = null;
    if (Game.replayState) {
        Game.rollback = 1;
        store.dispatch({ type: "reset", payload: Game.replayState });
    }

    store.dispatch(setMenu({ display: true, loading: false }));
    return;
};

export function endReplay(sceneData?: TScenesReplay): Promise<Node<unknown>> {
    return new Action({}, GameNames.END_REPLAY).run(

        function endReplay(callback: () => void) {

            if (Game.isReplayRunning) {
                endReplayFunc();
                return;

            }
            if (!sceneData) {
                store.dispatch(setAdvance({ canAdvance: true }));
                return;
            }
            if (!store.getState().menu.gallery?.[sceneData.ID]) {
                global.toast?.show(`Unlocked new gallery scene!`);
            }
            store.dispatch(setGallery({ ...sceneData, seen: true, gameState: store.getState().gameObject.present }));
            store.dispatch(setAdvance({ canAdvance: true }));
            onSaveGallery();
            callback();
            // console.log("current scene set:", name);
            // store.dispatch(setCurrentScene(name));
            // return func(args);
        }
        , !Game.isReplayRunning);

}